import { ValidationResult } from "./interface.validation";

export class EmailValidator {
    static emailFormat(item: any): ValidationResult {
        var EMAIL_REGEXP: any = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        if (item.value && !EMAIL_REGEXP.test(item.value)) {
            return { "incorrectMailFormat": true };
        }

        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/email.validation.ts
 **/